import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { VehicleFeature } from '@hyundai/ng-common-lib';
import { Store } from '@ngrx/store';

@Component({
    selector: 'lib-vehicle-comments-tab',
    standalone: true,
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    templateUrl: './vehicle-comments-tab.component.html',
})
export class VehicleCommentsTabComponent {
    store = inject(Store);

    vehicle = this.store.selectSignal(VehicleFeature.vehicleState.selectLoadedDetail);

    description = computed(() => {
        let description = this.vehicle()?.description;

        if (!description) return;

        // Format: https://services.mobile.de/manual/formatting-syntax.html

        description = description.replaceAll('----', '<hr class="border-grey-300 my-24">');

        // Replace **text** with <b>text</b>
        description = description.replaceAll(/\*\*(.+?)\*\*/g, '<b class="inline-block mt-8">$1</b>');

        // Replace \\ with <br>
        description = description.replaceAll('\\\\', '<br/>');

        // Replace * item list with <ul><li>item</li><li>item</li></ul>
        description = description.replaceAll(/\* (.+?)(?:\\\\|$)/g, '<li>$1</li>');
        description = description.replaceAll(/(<li>.*<\/li>)/gs, '<ul>$1</ul>');
        return description;
    });
}
